// @flow
import * as React from 'react';
import styled from 'styled-components';
import Dropdown from 'common/components/ui/Dropdown';
import { translate } from 'react-i18next';
import { type Period } from '../../domain/DashboardData';

export const DROPDOWN_ID = 'dashboard-period-selector';

const Wrapper = styled.div`
  width: 189px;
`;

interface Props {
  onChange: (period: Period) => void;
  t: any;
  value: Period;
}

export function DashboardPeriodSelector(props: Props) {
  const items = [
    { label: props.t('lastNbDays', { count: 7 }), value: 'weekly' },
    { label: props.t('lastNbDays', { count: 28 }), value: 'monthly' },
  ];

  return (
    <Wrapper>
      <Dropdown
        defaultValue={'weekly'}
        id={DROPDOWN_ID}
        items={items}
        onChange={props.onChange}
      />
    </Wrapper>
  );
}

export default translate('dashboard')(DashboardPeriodSelector);



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/v2/components/DashboardPeriodSelector.js